import { render, staticRenderFns } from "./CampanhasApiOficial.vue?vue&type=template&id=1d547c3d&scoped=true"
import script from "./CampanhasApiOficial.vue?vue&type=script&lang=js"
export * from "./CampanhasApiOficial.vue?vue&type=script&lang=js"
import style0 from "./CampanhasApiOficial.vue?vue&type=style&index=0&id=1d547c3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d547c3d",
  null
  
)

export default component.exports